import FingerprintJS from "@fingerprintjs/fingerprintjs"

let fingerprintPromise: Promise<string> | null = null

export const getFingerprintId = async (): Promise<string> => {
  if (!fingerprintPromise) {
    fingerprintPromise = (async () => {
      try {
        const fp = await FingerprintJS.load()
        const result = await fp.get()
        return result.visitorId
      } catch (error) {
        console.error("Error generating fingerprint:", error)
        return crypto.randomUUID().replace(/-/g, "")
      }
    })()
  }

  return fingerprintPromise
}
